module.exports = __webpack_public_path__ + "img/AutoCAD.0311019f.png";